export type Route =
  | {name: 'arena'}
  | {name: 'token'; address: string}
  | {name: 'launch'}
  | {name: 'leaderboard'}
  | {name: 'docs'}
  | {name: 'creator'};

/** Hash routing, so the site can be served as static files from any path. */
export function currentRoute(): Route {
  const [head = '', tail = ''] = location.hash.replace(/^#\/?/, '').split('/');
  switch (head) {
    case 'token':
      return tail ? {name: 'token', address: tail.toLowerCase()} : {name: 'arena'};
    case 'launch':
      return {name: 'launch'};
    case 'leaderboard':
      return {name: 'leaderboard'};
    case 'docs':
      return {name: 'docs'};
    case 'creator':
      return {name: 'creator'};
    default:
      return {name: 'arena'};
  }
}

export function navigate(hash: string): void {
  if (location.hash === hash) return;
  location.hash = hash;
}

export function onRouteChange(fn: (r: Route) => void): void {
  window.addEventListener('hashchange', () => fn(currentRoute()));
}
